export function formatTime(format){
  var time = new Date(format);
  let Y = time.getFullYear() + '-'
  let M = (time.getMonth() + 1 < 10 ? '0'+(time.getMonth() + 1) : time.getMonth() + 1) + '-'
  let D = time.getDate() < 10 ? '0'+time.getDate() : time.getDate()
  return Y+M+D
}